let support = (function () {
	if (!window.DOMParser) return false;
	var parser = new DOMParser();
	try {
		parser.parseFromString('x', 'text/html');
	} catch(err) {
		return false;
	}
	return true;
})();

let stringToHTML = function (str) {

	// If DOMParser is supported, use it
	if (support) {
		var parser = new DOMParser();
		var doc = parser.parseFromString(str, 'text/html');
		return doc.body;
	}

	// Otherwise, fallback to old-school method
	var dom = document.createElement('div');
	dom.innerHTML = str;
	return dom;

};

function setSwitchBtns() {
  document.querySelectorAll('.product-switches button').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      window.location.href = btn.getAttribute('data-href');
      /*fetch( '/products/'+btn.getAttribute('data-handle'))
        .then(res => res.text())
        .then((state)=>{
          let tmp = stringToHTML(state);
          document.querySelectorAll('main .shopify-section').forEach(function(section){
            let s_tmp = tmp.querySelector('#'+section.getAttribute('id'));
            if (s_tmp) {
              document.querySelector('#'+section.getAttribute('id')).innerHTML = s_tmp.innerHTML;
            }
          });
          document.dispatchEvent(new Event("reload_prod_section"));
          setSwitchBtns();
        });*/
    });
  });
}
setSwitchBtns();